const SENTRY = {
  TEST_ERROR_REPORTING: 'Testing frontend sentry error reporting.',
} as const;

export default SENTRY;
